import { create } from '@thoughtspot/logger';
import { validateShowGlobalAlertBannerEventPayloadObject } from './utils';
const logger = create('chart-to-ts > global-banner-events');
const getShowGlobalAlertBannerEventProcessor = (props) => {
    const { setIsGlobalBannerAlertVisible, setGlobalBannerAlertConfig } = props;
    return {
        validateEventPayload: (eventData) => {
            try {
                validateShowGlobalAlertBannerEventPayloadObject(eventData.payload);
            }
            catch (err) {
                logger.warn(err);
                return {
                    isValid: false,
                    errors: [err.toString()],
                };
            }
            return {
                isValid: true,
            };
        },
        executeEvent: async (eventData) => {
            setGlobalBannerAlertConfig(eventData.payload);
            setIsGlobalBannerAlertVisible(true);
            return Promise.resolve();
        },
    };
};
export { getShowGlobalAlertBannerEventProcessor };
//# sourceMappingURL=index.js.map